var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCompareArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 44 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#2F64ED",
  clipPath: "url(#clip0_2228_2143)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.419 23.72 3 16.302l7.418-7.419"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3 16.302 36-.001v10.483"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2228_2143"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0-2h44v42H0z"
})))));
export { SvgCompareArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0NCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8yMjI4XzIxNDMpIj4KICAgICAgICA8cGF0aCBkPSJNMTAuNDE4OSAyMy43MTk5TDMuMDAwNjMgMTYuMzAxNkwxMC40MTkgOC44ODMyNiIgc3Ryb2tlPSIjMkY2NEVEIiAvPgogICAgICAgIDxwYXRoIGQ9Ik0yLjk5OTg4IDE2LjMwMTZMMzkuMDAwMiAxNi4zMDA4TDM5LjAwMDIgMjYuNzgzOSIgc3Ryb2tlPSIjMkY2NEVEIiAvPgogICAgPC9nPgogICAgPGRlZnM+CiAgICAgICAgPGNsaXBQYXRoIGlkPSJjbGlwMF8yMjI4XzIxNDMiPgogICAgICAgICAgICA8cmVjdCB3aWR0aD0iNDQiIGhlaWdodD0iNDIiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0yKSIgLz4KICAgICAgICA8L2NsaXBQYXRoPgogICAgPC9kZWZzPgo8L3N2Zz4=";